export const CHANGE_EMAIL = "CHANGE_EMAIL";



export const changeEmailAction = () => ({
  type: CHANGE_EMAIL,

});